import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { ConditionExpressionPlainObject } from '../plainObjects/conditionExpression.plainObject';
import { MultiInputStreamBasePlainObject } from '../plainObjects/multiInputStreamBase.plainObject';

/* eslint-disable @typescript-eslint/no-explicit-any */
export abstract class MultiInputStreamVisitor extends BaseTransformationVisitor {
    protected get _transformation(): MultiInputStreamBasePlainObject {
        return this.transformation as MultiInputStreamBasePlainObject;
    }

    public visitTransformation(transformationContext: any): void {
        this.visit(transformationContext.configuration());
        this.visitExpression(transformationContext.expression());
    }

    public visitAnd(context: any): void {
        this.visit(context.left);
        this.visit(context.right);
    }

    public visitExpression(expression: any): void {
        this.visit(expression);
    }

    public visitEqNotEq(context: any): void {
        const condition = new ConditionExpressionPlainObject();
        condition.leftExpression = this._getText(context.left);
        condition.rightExpression = this._getText(context.right);
        condition.conditionType = this._getEqNotEqOperatorType(context);
        this._transformation.conditionExpressions.push(condition);
    }

    public visitComparison(context: any): void {
        const condition = new ConditionExpressionPlainObject();
        condition.leftExpression = this._getText(context.left);
        condition.rightExpression = this._getText(context.right);
        condition.conditionType = this._getComparisonOperatorType(context);
        this._transformation.conditionExpressions.push(condition);
    }

    private _getEqNotEqOperatorType(context: any): string {
        if (context.EQ()) {
            return '==';
        } else if (context.NOT_EQ()) {
            return '!=';
        } else if (context.EQ_NOCASE()) {
            return '<=>';
        } else if (context.EQ_NULL()) {
            return '===';
        }

        throw new Error(`Handle new type of EqNotEq operation ${this._getText(context.op)}`);
    }

    private _getComparisonOperatorType(context: any): string {
        if (context.GT()) {
            return '>';
        } else if (context.LT()) {
            return '<';
        } else if (context.GT_EQ()) {
            return '>=';
        } else if (context.LT_EQ()) {
            return '<=';
        }

        throw new Error(`Handle new type of comparision operation ${this._getText(context.op)}`);
    }
}
